import React from 'react';
import { Deal } from '../types/deal';
import DealBanner from './DealBanner';
import { useDealPending } from '../hooks/useAwaitingDeal';
import './DealBanner.css';

const urunnLogo = `${process.env.PUBLIC_URL}/logo.svg`;

interface CoBrandHeaderProps {
  deal: Deal | null | undefined;
}

/**
 * The promo header. Three states:
 *  - deal resolved → co-brand DealBanner (URUNN + partner)
 *  - deal expected but still loading → co-brand skeleton (no URUNN-only flash)
 *  - organic (no deal) → plain URUNN logo
 */
const CoBrandHeader: React.FC<CoBrandHeaderProps> = ({ deal }) => {
  const pending = useDealPending(!!deal);

  if (deal) {
    return <DealBanner deal={deal} />;
  }

  if (pending) {
    return (
      <div className="deal-banner">
        <div className="deal-banner-logos">
          <img src={urunnLogo} alt="Urunn" className="deal-banner-urunn-logo" />
          <div className="deal-banner-separator" style={{ borderColor: 'white' }}></div>
          <span className="deal-banner-partner-logo deal-banner-skeleton" aria-hidden="true" />
        </div>
      </div>
    );
  }

  return (
    <div className="hp-brand">
      <img src={urunnLogo} alt="Urunn" className="hp-brand-logo" />
    </div>
  );
};

export default CoBrandHeader;
